var _g, _path, _path2, _ellipse, _ellipse2, _path3, _path4, _ellipse3, _ellipse4, _path5, _path6, _ellipse5, _ellipse6, _g2, _mask, _g3, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTstorm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 420,
    height: 462,
    fill: "none",
    viewBox: "0 0 420 462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_29_285)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_29_285)",
    fillRule: "evenodd",
    d: "M205.519 240H138.1L107.258 338.638H141.485L112.991 440L207.496 316.565L157.177 316.565L205.519 240Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    filter: "url(#filter1_f_29_285)",
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_radial_29_285)",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M248.269 353.547C245.108 359.652 238.7 363.828 231.31 363.828C220.785 363.828 212.253 355.359 212.253 344.911C212.253 343.414 212.421 341.9 212.742 340.363C211.208 343.999 210.347 347.468 210.347 350.855C210.347 361.302 218.879 369.771 229.404 369.771C239.008 369.771 246.952 362.719 248.269 353.547Z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_radial_29_285)",
    d: "M248.27 350.761C248.27 361.209 239.738 369.678 229.214 369.678C218.689 369.678 210.157 361.209 210.157 350.761C210.157 340.313 218.351 329.071 229.214 314.611C238.361 328.675 248.27 340.313 248.27 350.761Z",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 234.073,
    cy: 335.212,
    fill: "url(#paint3_radial_29_285)",
    rx: 19.533,
    ry: 19.808
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 223.02,
    cy: 356.802,
    fill: "url(#paint4_radial_29_285)",
    rx: 19.533,
    ry: 19.808
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    filter: "url(#filter2_f_29_285)",
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_radial_29_285)",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M340.488 365.432C337.327 371.832 330.92 376.21 323.529 376.21C313.004 376.21 304.472 367.331 304.472 356.378C304.472 354.807 304.641 353.22 304.961 351.608C303.428 355.42 302.567 359.058 302.567 362.608C302.567 373.561 311.099 382.44 321.623 382.44C331.227 382.44 339.171 375.047 340.488 365.432Z",
    clipRule: "evenodd"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_radial_29_285)",
    d: "M340.49 362.51C340.49 373.463 331.958 382.342 321.433 382.342C310.908 382.342 302.376 373.463 302.376 362.51C302.376 351.557 310.571 339.771 321.433 324.611C330.58 339.355 340.49 351.557 340.49 362.51Z",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 326.292,
    cy: 346.208,
    fill: "url(#paint7_radial_29_285)",
    rx: 19.533,
    ry: 20.767
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.24,
    cy: 368.844,
    fill: "url(#paint8_radial_29_285)",
    rx: 19.533,
    ry: 20.767
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    filter: "url(#filter3_f_29_285)",
    opacity: 0.5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_radial_29_285)",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M298.792 431.853C294.683 439.73 286.352 445.118 276.745 445.118C263.063 445.118 251.971 434.19 251.971 420.709C251.971 418.776 252.19 416.822 252.607 414.838C250.613 419.53 249.494 424.007 249.494 428.377C249.494 441.858 260.585 452.786 274.267 452.786C286.752 452.786 297.08 443.687 298.792 431.853Z",
    clipRule: "evenodd"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_radial_29_285)",
    d: "M298.794 428.256C298.794 441.737 287.702 452.665 274.02 452.665C260.338 452.665 249.246 441.737 249.246 428.256C249.246 414.776 259.899 400.269 274.02 381.611C285.911 399.758 298.794 414.776 298.794 428.256Z",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.337,
    cy: 408.192,
    fill: "url(#paint11_radial_29_285)",
    rx: 25.393,
    ry: 25.559
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 265.968,
    cy: 436.052,
    fill: "url(#paint12_radial_29_285)",
    rx: 25.393,
    ry: 25.559
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_29_285)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 330.291,
    cy: 87.67,
    fill: "url(#paint13_linear_29_285)",
    rx: 87.709,
    ry: 87.67
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-1_29_285",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M319.761 307.584L150.358 307.584C67.3176 307.584 0 240.296 0 157.292C0 74.288 67.3176 7 150.358 7C217.131 7 273.738 50.5071 293.354 110.708C301.767 108.417 310.621 107.195 319.761 107.195C375.122 107.195 420 152.053 420 207.389C420 262.725 375.122 307.584 319.761 307.584Z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_29_285)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint14_linear_29_285)",
    fillRule: "evenodd",
    d: "M319.761 307.584L150.358 307.584C67.3176 307.584 0 240.296 0 157.292C0 74.288 67.3176 7 150.358 7C217.131 7 273.738 50.5071 293.354 110.708C301.767 108.417 310.621 107.195 319.761 107.195C375.122 107.195 420 152.053 420 207.389C420 262.725 375.122 307.584 319.761 307.584Z",
    clipRule: "evenodd"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.05,
    d: "M150.358 307.584V306.584V307.584ZM319.761 307.584V308.584V307.584ZM293.354 110.708L292.403 111.018L292.698 111.923L293.616 111.673L293.354 110.708ZM150.358 308.584L319.761 308.584V306.584L150.358 306.584V308.584ZM-1 157.292C-1 240.849 66.7657 308.584 150.358 308.584V306.584C67.8694 306.584 1 239.743 1 157.292H-1ZM150.358 6C66.7657 6 -1 73.7353 -1 157.292H1C1 74.8407 67.8694 8 150.358 8V6ZM294.304 110.398C274.558 49.7976 217.576 6 150.358 6V8C216.686 8 272.917 51.2166 292.403 111.018L294.304 110.398ZM293.616 111.673C301.945 109.405 310.711 108.195 319.761 108.195V106.195C310.532 106.195 301.589 107.429 293.091 109.743L293.616 111.673ZM319.761 108.195C374.57 108.195 419 152.606 419 207.389H421C421 151.501 375.673 106.195 319.761 106.195V108.195ZM419 207.389C419 262.173 374.57 306.584 319.761 306.584V308.584C375.673 308.584 421 263.278 421 207.389H419Z",
    mask: "url(#path-15-inside-1_29_285)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_29_285",
    width: 110.239,
    height: 210,
    x: 102.258,
    y: 235,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_29_285",
    stdDeviation: 2.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_29_285",
    width: 53.922,
    height: 45.409,
    x: 202.347,
    y: 332.363,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_29_285",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_29_285",
    width: 53.922,
    height: 46.833,
    x: 294.567,
    y: 343.608,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_29_285",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_29_285",
    width: 65.298,
    height: 53.948,
    x: 241.494,
    y: 406.838,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_29_285",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_29_285",
    width: 175.418,
    height: 195.34,
    x: 242.582,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "overlay",
    result: "effect1_innerShadow_29_285"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_29_285",
    width: 420,
    height: 349.231,
    x: 0,
    y: 7,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 48.647
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "normal",
    result: "effect1_innerShadow_29_285"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_285",
    x1: 157.377,
    x2: 157.377,
    y1: 240,
    y2: 440,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#FEC255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA031"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_29_285",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(229.404 352.143) rotate(-38.7703) scale(32.264 23.4224)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_29_285",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(229.214 352.049) rotate(-38.7715) scale(32.2644 23.4229)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_29_285",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(234.073 335.212) rotate(57.0173) scale(27.6285 7.95282)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_29_285",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(221.972 356.802) rotate(50.8095) scale(15.0789 7.27856)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_29_285",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(321.623 363.958) rotate(-40.0996) scale(32.8855 24.0925)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_29_285",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(321.433 363.86) rotate(-40.0996) scale(32.8855 24.0925)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_29_285",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(326.292 346.208) rotate(58.2414) scale(28.5757 8.06127)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_29_285",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(314.191 368.844) rotate(52.1287) scale(15.5213 7.41325)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_29_285",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(274.268 430.038) rotate(-38.5624) scale(41.8215 30.3112)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_29_285",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(274.02 429.918) rotate(-38.5626) scale(41.8216 30.3114)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_29_285",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(280.337 408.192) rotate(56.8215) scale(35.7291 10.3157)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_29_285",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(264.606 436.052) rotate(50.5996) scale(19.5151 9.43382)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_29_285",
    x1: 330.291,
    x2: 330.291,
    y1: 0,
    y2: 175.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA6C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_29_285",
    x1: 29.423,
    x2: 420.025,
    y1: 7,
    y2: 307.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTstorm);
export default __webpack_public_path__ + "static/media/Tstorm.1590f1142ff9abb7c1a761f0c0b31846.svg";
export { ForwardRef as ReactComponent };